/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21 4.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5ZM21 6c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3s-3 1.3432-3 3c0 .2361.0273.4658.0788.6862l-12.19 7.5016C5.5346 9.9256 4.3754 9 3 9c-1.6568 0-3 1.3431-3 3s1.3432 3 3 3c1.3754 0 2.5346-.9256 2.8888-2.1878l12.19 7.5016A3.0127 3.0127 0 0 0 18 21c0 1.6569 1.3431 3 3 3s3-1.3431 3-3-1.3431-3-3-3c-.8804 0-1.6723.3793-2.2211.9833L8.6498 12.75h9.4447C18.4275 14.0439 19.6021 15 21 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.3979 0-2.5725.956-2.9055 2.25H8.6498l10.1291-6.2333C19.3277 5.6207 20.1196 6 21 6ZM3 13.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5ZM22.5 21c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5ZM21 13.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z"
    clipRule="evenodd"
  />,
  'Endpoint'
);
